import React, { Component } from 'react';

import { NotPermittedAction } from './NotPermittedAction';

const defaultMessage = 'You can not change this field';

class Tooltip extends Component {
  render() {
    const {
      children,
      showTootip,
      message = defaultMessage,
      ...restProps
    } = this.props;

    if (!showTootip) return children;

    return (
      <NotPermittedAction message={message} {...restProps}>
        {children}
      </NotPermittedAction>
    );
  }
}

export default Tooltip;
